import React from 'react';
import { X, Check } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Comparison() {
  const {
    t
  } = useLanguage();
  const rows = [{
    label: t('comparison.row1'),
    book: true,
    restaurant: true,
    cookbook: false,
    class: true
  }, {
    label: t('comparison.row2'),
    book: true,
    restaurant: false,
    cookbook: true,
    class: false
  }, {
    label: t('comparison.row3'),
    book: true,
    restaurant: false,
    cookbook: false,
    class: false
  }, {
    label: t('comparison.row4'),
    book: true,
    restaurant: true,
    cookbook: false,
    class: false
  }, {
    label: t('comparison.row5'),
    book: true,
    restaurant: false,
    cookbook: false,
    class: false
  }, {
    label: t('comparison.row6'),
    book: true,
    restaurant: false,
    cookbook: true,
    class: false
  }];
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-155">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-156">
        <div className="text-center mb-12" data-id="element-157">
          <h2 className="text-4xl md:text-5xl text-[#3E2723] mb-4" data-id="element-158">
            {t('comparison.title')}
          </h2>
          <p className="text-xl text-[#3E2723]/70 max-w-2xl mx-auto" data-id="element-159">
            {t('comparison.desc')}
          </p>
        </div>

        <div className="bg-[#F5F1E8] rounded-2xl overflow-hidden shadow-lg border border-[#3E2723]/10" data-id="element-160">
          <div className="grid grid-cols-5 bg-[#3E2723] text-white text-xs md:text-base font-bold" data-id="element-161">
            <div className="p-3 md:p-5" data-id="element-162"></div>
            <div className="p-3 md:p-5 text-center bg-[#C2410C]" data-id="element-163">
              <div className="text-yellow-300" data-id="element-164">{t('comparison.thisBook')}</div>
              <div className="text-xs font-normal text-white/80 mt-1" data-id="element-165">
                $6.39
              </div>
            </div>
            <div className="p-3 md:p-5 text-center" data-id="element-166">
              <div data-id="element-167">{t('comparison.restaurant')}</div>
              <div className="text-xs font-normal text-white/70 mt-1" data-id="element-168">
                $120+
              </div>
            </div>
            <div className="p-3 md:p-5 text-center" data-id="element-169">
              <div data-id="element-170">{t('comparison.cookbook')}</div>
              <div className="text-xs font-normal text-white/70 mt-1" data-id="element-171">$35</div>
            </div>
            <div className="p-3 md:p-5 text-center" data-id="element-172">
              <div data-id="element-173">{t('comparison.class')}</div>
              <div className="text-xs font-normal text-white/70 mt-1" data-id="element-174">
                $400+
              </div>
            </div>
          </div>

          {rows.map((row, idx) => <div key={idx} className={`grid grid-cols-5 items-center text-sm md:text-base ${idx % 2 === 0 ? 'bg-white' : 'bg-[#FBF7F0]'}`} data-id="element-175">
              <div className="p-3 md:p-5 font-medium text-[#3E2723]" data-id="element-176">
                {row.label}
              </div>
              <div className="p-3 md:p-5 text-center bg-[#C2410C]/5" data-id="element-177">
                {row.book ? <Check className="w-5 h-5 md:w-6 md:h-6 text-[#14B8A6] mx-auto" data-id="element-178" /> : <X className="w-5 h-5 md:w-6 md:h-6 text-[#3E2723]/30 mx-auto" data-id="element-179" />}
              </div>
              <div className="p-3 md:p-5 text-center" data-id="element-180">
                {row.restaurant ? <Check className="w-5 h-5 md:w-6 md:h-6 text-[#14B8A6] mx-auto" data-id="element-181" /> : <X className="w-5 h-5 md:w-6 md:h-6 text-[#3E2723]/30 mx-auto" data-id="element-182" />}
              </div>
              <div className="p-3 md:p-5 text-center" data-id="element-183">
                {row.cookbook ? <Check className="w-5 h-5 md:w-6 md:h-6 text-[#14B8A6] mx-auto" data-id="element-184" /> : <X className="w-5 h-5 md:w-6 md:h-6 text-[#3E2723]/30 mx-auto" data-id="element-185" />}
              </div>
              <div className="p-3 md:p-5 text-center" data-id="element-186">
                {row.class ? <Check className="w-5 h-5 md:w-6 md:h-6 text-[#14B8A6] mx-auto" data-id="element-187" /> : <X className="w-5 h-5 md:w-6 md:h-6 text-[#3E2723]/30 mx-auto" data-id="element-188" />}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}